import ListItem from "@mui/material/ListItem";
import { librarySelectedTab, setSelectedLeftNav } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { setSearchText } from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { resetAllModifiedFilters, setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import {
  resetCorpSearchText,
  resetMyListsData,
  setCorpViewSelectedTab,
  setRecentlyViewed,
  setSelectedList,
  setSelectedListCategory
} from "components/features/Corp/CorpUser.Slice";
import { resetConfigTabSelected } from "components/features/dashboard/Dashboard.slice";
import { setCreatedDate } from "components/features/dashboard/HotelUserDashboard.slice";
import { setUseEffectState } from "components/features/dashboard/PropertyOverview/PropertyOverview.slice";
import { setSelectedAdminInncodes } from "components/features/MyPlans/myplans.slice";
import { isEmpty } from "lodash";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { resetAllSorting } from "redux/sorting.slice";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import { leftNavItems } from "utils/Types";

interface Props {
  label: string;
  link: string;
  Icon: any;
  paths?: any;
}

function Item(props: Props) {
  const { link, label, Icon, paths } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const savedFiltersAndLists = useAppSelector((state) => state.filters.savedFilter);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const isAboveProperty = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);
  const pinIndex = useAppSelector((state) => state.PropertyOverviewSlice.pinIndex);
  const innCode = useAppSelector((state) => state.app.innCode);
  const initialBookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);

  const isNotLeadershipDashboard =
    getLoggedInUserDetails()?.roleCategory !== "Leadership" ||
    !paths.includes(location.pathname.split("/")[1]) ||
    label !== "Home";

  const getSelectedTab = () => {
    if (paths.includes(location.pathname.split("/")[1])) dispatch(setSelectedLeftNav(label));
    return paths.includes(location.pathname.split("/")[1]);
  };

  const dispatchForPropertyUser = () => {
    dispatch(setUseEffectState(true));
  };

  const handleOnClick = () => {
    dispatch(resetAllModifiedFilters());
    dispatch(setSearchText(""));
    if (isNotLeadershipDashboard) {
      dispatch(setSelectedAdminInncodes([]));
      dispatch(librarySelectedTab(0));
      dispatch(resetConfigTabSelected({}));
      if (label !== "My Lists" && isCorp) {
        dispatch(resetMyListsData(savedFiltersAndLists["bookmarked"]?.[0]));
      }
      if (isCorp) {
        dispatch(setRecentlyViewed(""));
        dispatch(resetAllSorting({}));
        dispatch(resetCorpSearchText());
        dispatch(setCorpViewSelectedTab({ type: "dashboard", val: 0 }));
      }
      if (label === "Inncode Plans") {
        const innCodes = () => {
          if (innCode === DEFAULT_CORP_INNCODE) {
            return initialBookMarkInncodes?.map((item: any) => item?.innCode);
          } else {
            return [innCode];
          }
        };

        if (!isEmpty(innCodes()))
          dispatch(
            setPageFilter({
              pageName: filterPage.consultantInncodePlansDisplay,
              modifiedFilter: [
                {
                  id: 36,
                  options: innCodes(),
                  key: "innCode",
                  name: "Inncode"
                }
              ]
            })
          );
      }
      if (
        label === "Inncode Plans" ||
        label === "My Plans" ||
        label === leftNavItems.manageSuggestions ||
        label === leftNavItems.library
      )
        navigate(link, {
          state: {
            backButtonVisible: false
          }
        });
      else if (label === "My Lists") {
        dispatch(setSelectedList(savedFiltersAndLists["bookmarked"]?.[0]));
        dispatch(setSelectedListCategory("bookmarked"));
        dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));
        navigate(link, {
          state: {
            toggleOpen: isMobileScreen,
            backButtonVisible: false
          }
        });
      } else navigate(link);
      if (!isCorp && !isAboveProperty) {
        dispatchForPropertyUser();
      }
    } else {
      const query =
        pinIndex === 0 ? "/?parentTab=My+Dashboard" : "/?parentTab=Property+Overview&childTab=Property+Plans";
      navigate(query);
      dispatchForPropertyUser();
    }
    dispatch(
      setCreatedDate({
        createdDateFrom: null,
        createdDateTo: null
      })
    );
  };

  return (
    <ListItem
      sx={{
        color: `${tokens.Text.General.Secondary}`,
        display: "flex",
        flexDirection: isMobileScreen ? "row" : "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "7px",
        marginTop: "12px",
        cursor: "pointer",
        minHeight: isMobileScreen ? "30px" : "74px",
        borderRadius: "10px",
        "&.Mui-selected": {
          backgroundColor: tokens.Background.General.Color,
          color: `${tokens.Text.General.Color}`
        },
        ":hover": {
          backgroundColor: (theme) => theme.palette.secondary.main
        }
      }}
      selected={getSelectedTab()}
      onClick={handleOnClick}
    >
      {paths.includes(location.pathname.split("/")[1]) ? (
        <Icon stroke={tokens.Icon.General.Color} />
      ) : (
        <Icon stroke={tokens.Icon.General.Secondary} />
      )}
      <Typography
        variant={isMobileScreen ? "h4" : "label"}
        changeVariant={false}
        sx={{ marginLeft: isMobileScreen ? "5px" : 0, textAlign: "center" }}
      >
        {label}
      </Typography>
    </ListItem>
  );
}

export default Item;
